// utils/icons.js or utils/icons.tsx

export const Soc2Icon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <g clip-path="url(#soc2_svg__a)" filter="url(#soc2_svg__b)">
      <mask
        id="soc2_svg__c"
        width="96"
        height="96"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path
          fill="#fff"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
      </mask>
      <g mask="url(#soc2_svg__c)">
        <path
          fill="#353535"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="#D4C7F4"
          fillOpacity="0.24"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="#1D78BE"
          d="M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0m0 12c-19.883 0-36 16.117-36 36s16.117 36 36 36 36-16.118 36-36-16.118-36-36-36"
        ></path>
        <path
          fill="url(#soc2_svg__d)"
          d="M48 84c19.882 0 36-16.118 36-36S67.882 12 48 12 12 28.117 12 48s16.117 36 36 36"
        ></path>
        <g filter="url(#soc2_svg__e)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M82.995 2.18c2.523-6.223 7.477-10.02 9.638-11.14 2.055-.968 5.239-.117 1.538 11.02-4.626 13.917-7.208 10.24-13.585 22.01-6.376 11.772-1.858 1.004-7.5 6.867-5.644 5.863-5.782 6.643-12.764 14.655-6.98 8.011-7.212 7.027-1.327-2.342 5.886-9.369 5.286-9.272 14.11-21.292s6.736-12.002 9.89-19.779Z"
          ></path>
        </g>
        <g filter="url(#soc2_svg__f)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M89.557 16.616c2.524-6.221 7.478-10.02 9.64-11.14 2.054-.967 5.238-.116 1.537 11.02-4.626 13.918-7.208 10.24-13.584 22.012-6.377 11.77-1.86 1.003-7.502 6.867-5.643 5.864-5.781 6.642-12.762 14.654s-7.213 7.027-1.328-2.341 5.285-9.273 14.11-21.293 6.733-12.001 9.889-19.78Z"
          ></path>
        </g>
        <g filter="url(#soc2_svg__g)">
          <path
            fill="#fff"
            fillOpacity="0.2"
            d="M43.33-16.239c.396-6.887 7.39-10.61 10.84-11.61 3.35-.836 10.28.603 11.189 13.044C66.494.745 58.666-3.9 54.749 8.905c-3.915 12.804-2.935.906-9.767 6.936-6.833 6.03-6.53 6.92-14.422 15.261-7.891 8.343-9.077 7.164-4.358-2.912s3.605-10.049 12.18-22.798c8.577-12.75 4.456-13.022 4.95-21.63h-.001Z"
          ></path>
        </g>
        <g filter="url(#soc2_svg__h)">
          <path
            fill="#fff"
            fillOpacity="0.12"
            d="M-20.12 60.87c-1.171-7.402 10.653-9.536 16.71-9.678 5.928.012 19.053 3.49 24.147 17.308 6.367 17.272-9.292 10.05-12.958 22.936-3.667 12.887-5.142.18-16.033 4.876-10.89 4.695-10.09 5.747-22.287 12.672-12.2 6.926-14.702 5.314-8.808-4.376s3.854-9.967 16.096-21.51 4.598-12.975 3.134-22.228Z"
          ></path>
        </g>
        <g filter="url(#soc2_svg__i)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M108.682 40.054c2.524-6.222 7.478-10.02 9.639-11.14 2.055-.967 5.239-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.584 22.011-6.377 11.772-1.859 1.004-7.502 6.867s-5.781 6.643-12.762 14.655c-6.981 8.011-7.213 7.027-1.328-2.342s5.285-9.272 14.11-21.293 6.734-12 9.889-19.778"
          ></path>
        </g>
        <path
          fill="#D0C2F3"
          d="M47.999 84.999c20.435 0 37-16.565 37-37s-16.565-37-37-37-37 16.566-37 37 16.566 37 37 37"
        ></path>
        <path
          fill="#3DC9F5"
          d="M47.999 84.999c20.435 0 37-16.565 37-37s-16.565-37-37-37-37 16.566-37 37 16.566 37 37 37"
        ></path>
        <path
          fill="#282828"
          d="M64.157 54v-1.884l4.401-4.075q.561-.543.942-.978a3.7 3.7 0 0 0 .585-.851q.2-.423.2-.912 0-.543-.248-.935a1.63 1.63 0 0 0-.676-.61 2.1 2.1 0 0 0-.972-.218q-.567 0-.99.23a1.6 1.6 0 0 0-.652.658q-.23.429-.23 1.02h-2.48q0-1.213.549-2.107a3.67 3.67 0 0 1 1.54-1.382q.99-.49 2.281-.49 1.329 0 2.312.472.99.465 1.54 1.292.549.827.549 1.895 0 .7-.278 1.383-.27.682-.972 1.515-.7.827-1.974 1.986l-1.805 1.769v.084h5.192V54zm-5.737-8.036h-2.644a2.6 2.6 0 0 0-.296-.911 2.3 2.3 0 0 0-.573-.688 2.5 2.5 0 0 0-.809-.435q-.453-.15-.984-.151-.96 0-1.672.477-.712.471-1.105 1.376-.392.9-.392 2.186 0 1.322.392 2.221.399.9 1.11 1.359.713.458 1.649.458.525 0 .972-.138a2.6 2.6 0 0 0 .803-.405q.35-.271.58-.658.234-.387.325-.881l2.644.012a4.93 4.93 0 0 1-1.606 3.049 5.1 5.1 0 0 1-1.63.977q-.94.357-2.13.357-1.655 0-2.958-.749-1.299-.749-2.053-2.167-.749-1.419-.749-3.435 0-2.024.761-3.441.76-1.419 2.065-2.162 1.303-.748 2.934-.748 1.074 0 1.992.302a5 5 0 0 1 1.636.881q.712.573 1.159 1.407.453.833.58 1.907Zm-12.845 1.854q0 2.022-.766 3.44-.761 1.42-2.077 2.168-1.31.743-2.946.743-1.648 0-2.958-.749t-2.07-2.167q-.762-1.419-.761-3.435 0-2.023.76-3.441.761-1.418 2.07-2.162 1.31-.748 2.959-.748 1.636 0 2.946.748 1.316.743 2.077 2.162.766 1.418.766 3.44Zm-2.65 0q0-1.31-.392-2.21-.387-.9-1.093-1.364t-1.654-.465q-.948 0-1.654.465t-1.099 1.364q-.386.9-.386 2.21t.386 2.21q.393.899 1.099 1.364t1.654.464 1.654-.464q.706-.465 1.093-1.365.392-.9.392-2.21Zm-13.144-2.626q-.072-.731-.622-1.135-.55-.405-1.49-.405-.641 0-1.081.181a1.5 1.5 0 0 0-.676.49q-.23.313-.23.712-.012.331.139.58.157.246.429.428.27.176.628.308.355.127.76.217l1.11.266q.81.18 1.486.483.675.3 1.171.742.495.441.767 1.038.278.599.284 1.37-.007 1.137-.58 1.969-.567.827-1.642 1.286-1.069.453-2.578.453-1.497 0-2.608-.46-1.105-.458-1.726-1.358-.615-.905-.646-2.24h2.53q.041.622.355 1.04.32.41.852.62a3.4 3.4 0 0 0 1.213.206q.664 0 1.153-.193.495-.194.767-.537a1.24 1.24 0 0 0 .271-.791q0-.417-.247-.7-.241-.284-.712-.483a7 7 0 0 0-1.141-.363l-1.347-.338q-1.563-.38-2.469-1.189-.904-.81-.9-2.18-.005-1.122.598-1.961.61-.84 1.673-1.31 1.062-.471 2.414-.471 1.377 0 2.403.47 1.032.472 1.606 1.31.573.84.592 1.945z"
        ></path>
        <path
          stroke="#282828"
          strokeWidth="2"
          d="M47.999 84.999c20.435 0 37-16.565 37-37s-16.565-37-37-37-37 16.566-37 37 16.566 37 37 37Z"
        ></path>
        <path
          stroke="url(#soc2_svg__j)"
          strokeWidth="0.375"
          d="M20.28 36.813h55.5"
        ></path>
        <path
          stroke="url(#soc2_svg__k)"
          strokeWidth="0.375"
          d="M20.28 58.312h55.5"
        ></path>
        <path
          fill="#282828"
          d="M59.21 61.181V67h-.705v-5.08h-.034l-1.42.943v-.716l1.454-.966zM50.235 67v-5.82h3.511v.625H50.94v1.966h2.625v.625H50.94v1.977h2.852V67zm-5.078 0v-5.82h1.966q.684 0 1.12.248.436.243.647.661.21.419.21.932 0 .515-.21.935-.207.42-.642.67-.435.248-1.114.248h-1.409v-.626h1.386q.47 0 .753-.161a.97.97 0 0 0 .412-.438 1.5 1.5 0 0 0 .131-.628q0-.35-.13-.625a.93.93 0 0 0-.416-.432q-.285-.159-.76-.159h-1.24V67zm-5.82-5.819h.806l1.614 2.716h.068l1.614-2.716h.807l-2.102 3.42V67h-.705v-2.397l-2.102-3.42Zm-4.951.625v-.625h4.363v.625h-1.83V67h-.704v-5.194h-1.83ZM56.68 34h-1.05l2.356-6.546h1.14l2.356 6.545h-1.048l-1.85-5.356h-.052zm.175-2.564h3.401v.831h-3.4v-.83ZM51.064 34v-6.546h2.333q.764 0 1.266.278.502.279.751.76.25.48.25 1.081 0 .604-.253 1.087-.25.48-.755.76-.501.279-1.262.278H51.79v-.837h1.515q.481 0 .783-.166.3-.17.44-.46a1.5 1.5 0 0 0 .141-.662q0-.371-.14-.658a1 1 0 0 0-.445-.451q-.3-.163-.792-.163h-1.24v5.698h-.988Zm-1.181-4.417h-.998a1.52 1.52 0 0 0-.597-.975 1.7 1.7 0 0 0-.508-.256 2 2 0 0 0-.592-.086q-.566 0-1.013.284-.444.285-.703.834-.256.55-.256 1.343 0 .798.256 1.348.26.55.706.831a1.85 1.85 0 0 0 1.007.282q.31 0 .588-.083a1.7 1.7 0 0 0 .508-.253 1.55 1.55 0 0 0 .604-.962l.998.003a2.7 2.7 0 0 1-.31.889q-.228.402-.585.697a2.7 2.7 0 0 1-.812.45q-.457.16-.997.16a2.87 2.87 0 0 1-1.515-.403 2.8 2.8 0 0 1-1.049-1.16q-.38-.755-.38-1.8 0-1.047.384-1.799a2.8 2.8 0 0 1 1.048-1.157q.664-.405 1.512-.405.52 0 .971.15.455.147.815.434.361.285.598.697.236.41.32.937m-6.875-2.129v6.545h-.988v-6.545zM36.271 34h-1.048l2.356-6.546h1.14l2.356 6.545h-1.048l-1.85-5.356h-.052zm.176-2.564h3.4v.831h-3.4v-.83Z"
        ></path>
      </g>
      <path
        stroke="#fff"
        strokeOpacity="0.08"
        d="M48 .5C74.233.5 95.5 21.767 95.5 48c0 26.234-21.266 47.5-47.5 47.5S.5 74.233.5 48C.5 21.766 21.767.5 48 .5Z"
      ></path>
    </g>
    <defs>
      <filter
        id="soc2_svg__b"
        width="96.001"
        height="98.001"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="2"></feOffset>
        <feGaussianBlur stdDeviation="2"></feGaussianBlur>
        <feComposite
          in2="hardAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
        ></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"></feColorMatrix>
        <feBlend in2="shape" result="effect1_innerShadow_1_1842"></feBlend>
      </filter>
      <filter
        id="soc2_svg__e"
        width="59.057"
        height="78.255"
        x="45.817"
        y="-18.257"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_1_1842"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="soc2_svg__f"
        width="59.057"
        height="78.256"
        x="52.379"
        y="-3.821"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_1_1842"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="soc2_svg__g"
        width="60.048"
        height="82.681"
        x="14.422"
        y="-37.042"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_1_1842"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="soc2_svg__h"
        width="109.64"
        height="107.037"
        x="-64.898"
        y="28.692"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_1_1842"
          stdDeviation="11.25"
        ></feGaussianBlur>
      </filter>
      <filter
        id="soc2_svg__i"
        width="59.057"
        height="78.255"
        x="71.504"
        y="19.618"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_1_1842"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <linearGradient
        id="soc2_svg__d"
        x1="47.999"
        x2="47.999"
        y1="11.999"
        y2="83.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.2"></stop>
      </linearGradient>
      <linearGradient
        id="soc2_svg__j"
        x1="20.28"
        x2="75.78"
        y1="36.813"
        y2="36.813"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.5" stopColor="#282828"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="soc2_svg__k"
        x1="20.28"
        x2="75.78"
        y1="58.312"
        y2="58.312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.5" stopColor="#282828"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="soc2_svg__a">
        <path fill="#fff" d="M0 0h96v96H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export const CasaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <g filter="url(#casa_svg__a)">
      <g clipPath="url(#casa_svg__b)">
        <path
          fill="#353535"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="#D4C7F4"
          fillOpacity="0.24"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="url(#casa_svg__c)"
          d="M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0m0 12c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36"
        ></path>
        <circle cx="48" cy="48" r="36" fill="url(#casa_svg__d)"></circle>
        <g filter="url(#casa_svg__e)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M82.995 2.18c2.524-6.222 7.477-10.02 9.639-11.14 2.054-.967 5.238-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.585 22.011-6.376 11.772-1.858 1.004-7.501 6.867s-5.782 6.643-12.763 14.655c-6.98 8.011-7.212 7.027-1.327-2.342s5.285-9.272 14.11-21.292S79.84 9.957 82.994 2.18Z"
          ></path>
        </g>
        <g filter="url(#casa_svg__f)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M89.557 16.617c2.524-6.221 7.478-10.02 9.64-11.14 2.054-.967 5.238-.116 1.537 11.02-4.626 13.918-7.208 10.24-13.584 22.012-6.377 11.771-1.859 1.003-7.502 6.867s-5.781 6.642-12.762 14.654-7.213 7.027-1.328-2.341 5.285-9.273 14.11-21.293 6.734-12.001 9.89-19.779Z"
          ></path>
        </g>
        <g filter="url(#casa_svg__g)">
          <path
            fill="#fff"
            fillOpacity="0.2"
            d="M43.331-16.238c.395-6.887 7.39-10.61 10.839-11.61 3.351-.836 10.28.603 11.189 13.044C66.494.746 58.666-3.9 54.749 8.906c-3.915 12.804-2.935.906-9.767 6.936-6.833 6.03-6.53 6.919-14.422 15.261-7.891 8.343-9.077 7.164-4.358-2.912s3.605-10.049 12.18-22.798c8.577-12.75 4.456-13.022 4.95-21.63Z"
          ></path>
        </g>
        <g filter="url(#casa_svg__h)">
          <path
            fill="#fff"
            fillOpacity="0.12"
            d="M-20.118 60.871c-1.172-7.402 10.652-9.536 16.71-9.678 5.927.012 19.052 3.49 24.146 17.308 6.367 17.272-9.292 10.05-12.958 22.936-3.667 12.887-5.142.18-16.033 4.876-10.89 4.695-10.089 5.747-22.287 12.672-12.199 6.926-14.702 5.314-8.808-4.376s3.854-9.967 16.096-21.51 4.598-12.975 3.134-22.228"
          ></path>
        </g>
        <g filter="url(#casa_svg__i)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M108.682 40.055c2.524-6.222 7.478-10.02 9.639-11.14 2.055-.967 5.239-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.584 22.011-6.377 11.772-1.859 1.004-7.502 6.867s-5.781 6.643-12.762 14.655c-6.981 8.011-7.213 7.027-1.328-2.342s5.285-9.272 14.11-21.293 6.734-12 9.889-19.778"
          ></path>
        </g>
        <circle cx="48" cy="48" r="37" fill="#D0C2F3"></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          fill="url(#casa_svg__j)"
          fillOpacity="0.16"
        ></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          stroke="#282828"
          strokeWidth="2"
        ></circle>
        <path
          fill="#282828"
          d="M35.982 28.065v-.883h4.642v.883h-1.798V33h-1.045v-4.935zm6.591-.883V33H41.52v-5.818h1.054ZM43.715 33v-5.818h3.784v.883h-2.73v1.58h2.534v.883h-2.534v1.589h2.752V33zm4.859 0v-5.818h2.182q.67 0 1.125.233.458.233.69.653.236.418.236.975 0 .56-.239.971a1.58 1.58 0 0 1-.696.634q-.46.221-1.13.221h-1.554v-.875h1.411q.393 0 .643-.108a.76.76 0 0 0 .369-.32q.122-.214.122-.523t-.122-.529a.78.78 0 0 0-.372-.335q-.25-.116-.645-.116h-.966V33zm3.006-2.636L53.02 33h-1.176l-1.415-2.636zm6.213 2.716q-.614 0-1.091-.21a1.8 1.8 0 0 1-.75-.586 1.5 1.5 0 0 1-.293-.866h1.068q.015.235.157.412a.94.94 0 0 0 .377.27q.237.096.529.096.312 0 .554-.108a.9.9 0 0 0 .378-.307.76.76 0 0 0 .133-.451.8.8 0 0 0-.136-.466.9.9 0 0 0-.404-.316 1.6 1.6 0 0 0-.63-.113h-.515v-.813h.515q.304 0 .53-.105a.86.86 0 0 0 .362-.295.76.76 0 0 0 .128-.446.78.78 0 0 0-.111-.43.75.75 0 0 0-.316-.286 1.04 1.04 0 0 0-.474-.103 1.25 1.25 0 0 0-.494.097.9.9 0 0 0-.367.276.7.7 0 0 0-.148.42h-1.014q.012-.489.282-.858.272-.372.727-.58a2.4 2.4 0 0 1 1.02-.21 2.2 2.2 0 0 1 1.011.219q.431.216.668.582.235.368.235.81.004.492-.29.824a1.36 1.36 0 0 1-.76.435v.045q.613.085.94.455.33.366.326.912 0 .488-.278.874a1.85 1.85 0 0 1-.761.603 2.7 2.7 0 0 1-1.108.219"
        ></path>
        <path
          stroke="url(#casa_svg__k)"
          strokeWidth="0.375"
          d="M20.281 36.813h55.5"
        ></path>
        <path
          stroke="url(#casa_svg__l)"
          strokeWidth="0.375"
          d="M20.281 58.313h55.5"
        ></path>
        <path
          fill="#282828"
          d="M33.17 65.074h-.886a1.35 1.35 0 0 0-.53-.867 1.5 1.5 0 0 0-.453-.227 1.8 1.8 0 0 0-.525-.077q-.503 0-.9.253a1.72 1.72 0 0 0-.626.742q-.227.488-.227 1.193 0 .71.227 1.199.23.488.628.738t.895.25q.276 0 .523-.074.25-.075.451-.224a1.37 1.37 0 0 0 .537-.855l.887.003q-.071.43-.276.79a2.2 2.2 0 0 1-.52.619q-.315.258-.721.4a2.7 2.7 0 0 1-.887.142q-.755 0-1.346-.357a2.5 2.5 0 0 1-.932-1.032q-.338-.67-.338-1.6t.34-1.599q.342-.67.933-1.028.59-.36 1.343-.36.464 0 .864.133.403.13.724.386.322.253.532.62.21.364.284.832ZM34.222 69v-5.818h3.648v.755H35.1v1.773h2.58v.753H35.1v1.781h2.804V69zm4.82 0v-5.818h2.074q.676 0 1.123.233.448.233.67.645.222.409.222.946 0 .535-.225.94a1.5 1.5 0 0 1-.67.628q-.447.225-1.122.224H39.54v-.755h1.492q.426 0 .693-.123.27-.122.395-.355a1.2 1.2 0 0 0 .125-.56q0-.33-.128-.57a.83.83 0 0 0-.395-.37q-.267-.13-.701-.13h-1.103V69h-.877Zm2.873-2.625L43.35 69h-1l-1.409-2.625h.972Zm1.997-2.438v-.755h4.503v.755h-1.816V69h-.875v-5.063zm6.376-.755V69h-.878v-5.818zM51.565 69v-5.818h3.608v.755h-2.73v1.773h2.471v.753h-2.471V69zm5.565-5.818V69h-.878v-5.818zM58.41 69v-5.818h3.648v.755h-2.77v1.773h2.58v.753h-2.58v1.781h2.804V69zm6.704 0H63.23v-5.818h1.943q.855 0 1.469.35.614.346.94.996.33.648.33 1.554 0 .909-.332 1.563-.33.653-.955 1.006-.625.35-1.511.349m-1.006-.767h.957q.666 0 1.105-.25.441-.253.66-.73.218-.48.218-1.17 0-.685-.218-1.162a1.55 1.55 0 0 0-.645-.725q-.429-.247-1.066-.247h-1.011zm-27.65-22.795H33.97a2.4 2.4 0 0 0-.278-.858q-.21-.381-.54-.648a2.4 2.4 0 0 0-.761-.41 2.9 2.9 0 0 0-.926-.141q-.903 0-1.574.449-.67.443-1.04 1.295-.37.846-.37 2.057 0 1.244.37 2.09.375.847 1.046 1.28.67.43 1.55.431.495 0 .915-.13.428-.132.756-.381.33-.255.546-.62.221-.363.306-.83l2.49.012a4.64 4.64 0 0 1-1.511 2.87 4.8 4.8 0 0 1-1.535.92q-.887.335-2.006.335-1.557 0-2.784-.704-1.223-.705-1.932-2.04-.704-1.335-.704-3.233 0-1.905.715-3.239.716-1.335 1.944-2.034 1.227-.705 2.761-.704 1.012 0 1.875.284.87.284 1.54.83.67.539 1.09 1.323.427.784.546 1.795ZM40.01 53h-2.636l4.017-11.636h3.17L48.572 53h-2.637l-2.914-8.977h-.091zm-.165-4.574h6.228v1.92h-6.228zM56.02 44.71q-.068-.687-.585-1.068-.518-.38-1.403-.38-.603 0-1.017.17-.416.165-.637.46-.216.295-.216.67a.96.96 0 0 0 .13.546q.15.233.404.403.256.165.591.29.335.12.716.205l1.046.25a7.4 7.4 0 0 1 1.397.454q.637.285 1.103.7.465.414.721.976.261.563.267 1.29-.005 1.069-.545 1.852-.534.78-1.546 1.21-1.005.427-2.426.427-1.41 0-2.454-.432-1.04-.432-1.625-1.278-.58-.853-.608-2.108h2.38q.04.584.336.977.3.386.8.585a3.2 3.2 0 0 0 1.143.193q.624 0 1.085-.181.465-.182.722-.506a1.17 1.17 0 0 0 .255-.745.97.97 0 0 0-.233-.659q-.227-.267-.67-.454a7 7 0 0 0-1.074-.341l-1.267-.318q-1.472-.358-2.324-1.12-.852-.76-.846-2.05-.006-1.057.562-1.847.574-.79 1.574-1.233t2.273-.444q1.295 0 2.26.444.973.443 1.512 1.233.54.789.557 1.83H56.02ZM61.931 53h-2.636l4.017-11.636h3.17L70.494 53h-2.637l-2.915-8.977h-.09L61.932 53Zm-.165-4.574h6.228v1.92h-6.228z"
        ></path>
      </g>
      <path
        stroke="#fff"
        strokeOpacity="0.08"
        d="M48 .5C74.234.5 95.5 21.767 95.5 48c0 26.234-21.266 47.5-47.5 47.5C21.767 95.5.5 74.234.5 48 .5 21.767 21.767.5 48 .5Z"
      ></path>
    </g>
    <defs>
      <filter
        id="casa_svg__a"
        width="96"
        height="98"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="2"></feOffset>
        <feGaussianBlur stdDeviation="2"></feGaussianBlur>
        <feComposite
          in2="hardAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
        ></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"></feColorMatrix>
        <feBlend in2="shape" result="effect1_innerShadow_250_8095"></feBlend>
      </filter>
      <filter
        id="casa_svg__e"
        width="59.057"
        height="78.256"
        x="45.817"
        y="-18.257"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8095"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="casa_svg__f"
        width="59.057"
        height="78.256"
        x="52.38"
        y="-3.819"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8095"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="casa_svg__g"
        width="60.047"
        height="82.682"
        x="14.423"
        y="-37.042"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8095"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="casa_svg__h"
        width="109.64"
        height="107.036"
        x="-64.897"
        y="28.693"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8095"
          stdDeviation="11.25"
        ></feGaussianBlur>
      </filter>
      <filter
        id="casa_svg__i"
        width="59.057"
        height="78.256"
        x="71.505"
        y="19.618"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8095"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <linearGradient
        id="casa_svg__c"
        x1="48"
        x2="48"
        y1="0"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.2"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.02"></stop>
      </linearGradient>
      <linearGradient
        id="casa_svg__d"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.2"></stop>
      </linearGradient>
      <linearGradient
        id="casa_svg__j"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="casa_svg__k"
        x1="20.281"
        x2="75.781"
        y1="37.5"
        y2="37.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.5" stopColor="#282828"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="casa_svg__l"
        x1="20.281"
        x2="75.781"
        y1="59"
        y2="59"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="0.5" stopColor="#282828"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="casa_svg__b">
        <path
          fill="#fff"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

export const GdprIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <g filter="url(#gdpr_svg__a)">
      <g clipPath="url(#gdpr_svg__b)">
        <path
          fill="#353535"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="#2758A4"
          fillOpacity="0.24"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="url(#gdpr_svg__c)"
          d="M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0m0 12c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36"
        ></path>
        <circle cx="48" cy="48" r="36" fill="url(#gdpr_svg__d)"></circle>
        <g filter="url(#gdpr_svg__e)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M82.995 2.18c2.524-6.222 7.477-10.02 9.639-11.14 2.054-.967 5.238-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.585 22.011-6.376 11.772-1.858 1.004-7.501 6.867s-5.782 6.643-12.763 14.655c-6.98 8.011-7.212 7.027-1.327-2.342s5.285-9.272 14.11-21.292S79.84 9.957 82.994 2.18Z"
          ></path>
        </g>
        <g filter="url(#gdpr_svg__f)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M89.557 16.617c2.524-6.221 7.478-10.02 9.64-11.14 2.054-.967 5.238-.116 1.537 11.02-4.626 13.918-7.208 10.24-13.584 22.012-6.377 11.771-1.859 1.003-7.502 6.867s-5.781 6.642-12.762 14.654-7.213 7.027-1.328-2.341 5.285-9.273 14.11-21.293 6.734-12.001 9.89-19.779Z"
          ></path>
        </g>
        <g filter="url(#gdpr_svg__g)">
          <path
            fill="#fff"
            fillOpacity="0.2"
            d="M43.331-16.238c.395-6.887 7.39-10.61 10.839-11.61 3.351-.836 10.28.603 11.189 13.044C66.494.746 58.666-3.9 54.749 8.906c-3.915 12.804-2.935.906-9.767 6.936-6.833 6.03-6.53 6.919-14.422 15.261-7.891 8.343-9.077 7.164-4.358-2.912s3.605-10.049 12.18-22.798c8.577-12.75 4.456-13.022 4.95-21.63Z"
          ></path>
        </g>
        <g filter="url(#gdpr_svg__h)">
          <path
            fill="#fff"
            fillOpacity="0.12"
            d="M-20.118 60.871c-1.172-7.402 10.652-9.536 16.71-9.678 5.927.012 19.052 3.49 24.146 17.308 6.367 17.272-9.292 10.05-12.958 22.936-3.667 12.887-5.142.18-16.033 4.876-10.89 4.695-10.089 5.747-22.287 12.672-12.199 6.926-14.702 5.314-8.808-4.376s3.854-9.967 16.096-21.51 4.598-12.975 3.134-22.228"
          ></path>
        </g>
        <g filter="url(#gdpr_svg__i)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M108.682 40.055c2.524-6.222 7.478-10.02 9.639-11.14 2.055-.967 5.239-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.584 22.011-6.377 11.772-1.859 1.004-7.502 6.867s-5.781 6.643-12.762 14.655c-6.981 8.011-7.213 7.027-1.328-2.342s5.285-9.272 14.11-21.293 6.734-12 9.889-19.778"
          ></path>
        </g>
        <circle cx="48" cy="48" r="37" fill="#1D51A0"></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          fill="url(#gdpr_svg__j)"
          fillOpacity="0.16"
        ></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          stroke="#282828"
          strokeWidth="2"
        ></circle>
        <path
          fill="#fff"
          d="M34.423 46.125a2.6 2.6 0 0 0-.336-.733 2.1 2.1 0 0 0-.528-.545 2.3 2.3 0 0 0-.705-.347 3 3 0 0 0-.869-.12q-.892 0-1.568.444-.67.443-1.046 1.29-.375.84-.375 2.056t.37 2.069q.37.852 1.045 1.3.676.444 1.597.444.835 0 1.426-.295.596-.301.909-.847.318-.546.318-1.29l.5.074h-3v-1.852h4.87v1.466q0 1.533-.648 2.636a4.4 4.4 0 0 1-1.784 1.693q-1.136.591-2.603.591-1.636 0-2.875-.721-1.239-.728-1.931-2.063-.688-1.341-.688-3.182 0-1.414.41-2.523a5.4 5.4 0 0 1 1.158-1.886 5 5 0 0 1 1.733-1.176 5.6 5.6 0 0 1 2.142-.403q.99 0 1.841.29a4.9 4.9 0 0 1 1.512.806q.664.523 1.085 1.244.42.717.54 1.58zM43.003 54H38.88V42.364h4.159q1.755 0 3.022.699a4.7 4.7 0 0 1 1.95 1.994q.687 1.3.687 3.113 0 1.819-.688 3.125a4.72 4.72 0 0 1-1.96 2.006Q44.777 54 43.005 54Zm-1.664-2.108H42.9q1.092 0 1.835-.386.75-.393 1.126-1.21.38-.825.38-2.126 0-1.29-.38-2.108-.375-.818-1.12-1.204-.744-.387-1.835-.386h-1.568zM50.519 54V42.364h4.591q1.325 0 2.256.505a3.42 3.42 0 0 1 1.42 1.392q.495.887.495 2.046t-.5 2.045a3.45 3.45 0 0 1-1.45 1.381q-.943.495-2.283.494H52.12v-1.971h2.529q.71 0 1.17-.245a1.6 1.6 0 0 0 .694-.687 2.16 2.16 0 0 0 .232-1.017q0-.58-.233-1.012a1.56 1.56 0 0 0-.693-.676q-.465-.244-1.181-.244h-1.66V54zm10.36 0V42.364h4.59q1.32 0 2.25.471.938.466 1.427 1.324.495.852.494 2.006 0 1.159-.5 1.994-.5.83-1.449 1.273-.943.443-2.284.443h-3.074v-1.977h2.676q.705 0 1.17-.194a1.4 1.4 0 0 0 .694-.579q.233-.387.233-.96 0-.58-.233-.977a1.43 1.43 0 0 0-.699-.603q-.466-.21-1.176-.21h-1.66V54zm6.284-5.295L70.055 54h-2.716l-2.83-5.295z"
        ></path>
        <path
          fill="#FFCE00"
          d="m71.563 31.375-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.734c0 .254.292.423.5.254l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.65 1.042-1.397c.168-.212 0-.508-.25-.508h-1.71l-.96-1.438c-.167-.212-.5-.17-.584.084m-9.984-9.984-.542 1.65-1.67.508c-.25.084-.291.423-.083.55l1.377 1.015-.041 1.735c0 .254.291.423.5.254l1.419-1.016 1.626.593c.25.084.501-.127.418-.381l-.543-1.65 1.043-1.396c.168-.212 0-.508-.25-.508h-1.71l-.96-1.439c-.167-.211-.5-.169-.584.085M23.45 31.375l-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.734c0 .254.291.423.5.254l1.418-1.015 1.628.592c.25.085.5-.127.417-.38l-.542-1.65 1.043-1.397c.167-.212 0-.508-.25-.508h-1.711l-.96-1.438c-.167-.212-.5-.17-.584.084m9.988-9.984-.542 1.65-1.669.508c-.25.084-.292.423-.083.55l1.376 1.015-.041 1.735c0 .254.291.423.5.254l1.42-1.016 1.626.593c.25.084.5-.127.417-.381l-.542-1.65 1.043-1.396c.167-.212 0-.508-.25-.508h-1.711l-.96-1.439c-.167-.211-.5-.169-.584.085m13.99-4.171-.542 1.65-1.669.508c-.25.084-.292.423-.084.55l1.377 1.015-.042 1.735c0 .254.293.423.501.254l1.419-1.016 1.627.593c.25.084.5-.127.417-.381l-.542-1.65 1.043-1.396c.166-.212 0-.508-.25-.508h-1.711l-.96-1.439c-.166-.211-.5-.169-.584.085m.382 56.37-.543 1.65-1.669.507c-.25.085-.292.423-.084.55l1.378 1.016-.043 1.734c0 .254.293.423.501.254l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.651 1.043-1.396c.166-.212 0-.508-.25-.508h-1.711l-.96-1.438c-.166-.212-.5-.17-.584.084Zm13.769-4.54-.542 1.65-1.67.507c-.25.085-.291.423-.083.55l1.377 1.015-.041 1.735c0 .254.291.423.5.254l1.419-1.015 1.626.592c.25.085.501-.127.418-.38l-.543-1.651 1.043-1.396c.168-.212 0-.508-.25-.508h-1.71l-.96-1.439c-.167-.211-.5-.169-.584.085Zm-28.141 0-.542 1.65-1.669.507c-.25.085-.292.423-.083.55l1.376 1.015-.041 1.735c0 .254.291.423.5.254l1.42-1.015 1.626.592c.25.085.5-.127.417-.38l-.542-1.651 1.043-1.396c.167-.212 0-.508-.25-.508h-1.711l-.96-1.439c-.167-.211-.5-.169-.584.085Zm38.125-9.683-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.735c0 .253.292.423.5.253l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.65 1.042-1.397c.168-.211 0-.508-.25-.508h-1.71l-.96-1.438c-.167-.212-.5-.17-.584.084m-48.113 0-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.735c0 .253.291.423.5.253l1.418-1.015 1.628.592c.25.085.5-.127.417-.38l-.542-1.65 1.043-1.397c.167-.211 0-.508-.25-.508h-1.711l-.96-1.438c-.167-.212-.5-.17-.584.084"
        ></path>
      </g>
      <path
        stroke="#fff"
        strokeOpacity="0.08"
        d="M48 .5C74.234.5 95.5 21.767 95.5 48c0 26.234-21.266 47.5-47.5 47.5C21.767 95.5.5 74.234.5 48 .5 21.767 21.767.5 48 .5Z"
      ></path>
    </g>
    <defs>
      <filter
        id="gdpr_svg__a"
        width="96"
        height="98"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="2"></feOffset>
        <feGaussianBlur stdDeviation="2"></feGaussianBlur>
        <feComposite
          in2="hardAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
        ></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"></feColorMatrix>
        <feBlend in2="shape" result="effect1_innerShadow_250_8047"></feBlend>
      </filter>
      <filter
        id="gdpr_svg__e"
        width="59.057"
        height="78.256"
        x="45.817"
        y="-18.257"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8047"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="gdpr_svg__f"
        width="59.057"
        height="78.256"
        x="52.38"
        y="-3.819"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8047"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="gdpr_svg__g"
        width="60.047"
        height="82.682"
        x="14.423"
        y="-37.042"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8047"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="gdpr_svg__h"
        width="109.64"
        height="107.036"
        x="-64.897"
        y="28.693"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8047"
          stdDeviation="11.25"
        ></feGaussianBlur>
      </filter>
      <filter
        id="gdpr_svg__i"
        width="59.057"
        height="78.256"
        x="71.505"
        y="19.618"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8047"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <linearGradient
        id="gdpr_svg__c"
        x1="48"
        x2="48"
        y1="0"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.2"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.02"></stop>
      </linearGradient>
      <linearGradient
        id="gdpr_svg__d"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.2"></stop>
      </linearGradient>
      <linearGradient
        id="gdpr_svg__j"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="gdpr_svg__b">
        <path
          fill="#fff"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

export const CcpaIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 96 96"
    {...props}
  >
    <g filter="url(#ccpa_svg__a)">
      <g clipPath="url(#ccpa_svg__b)">
        <path
          fill="#353535"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="#172C6E"
          fillOpacity="0.24"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
        <path
          fill="url(#ccpa_svg__c)"
          d="M48 0c26.51 0 48 21.49 48 48S74.51 96 48 96 0 74.51 0 48 21.49 0 48 0m0 12c-19.882 0-36 16.118-36 36s16.118 36 36 36 36-16.118 36-36-16.118-36-36-36"
        ></path>
        <circle cx="48" cy="48" r="36" fill="url(#ccpa_svg__d)"></circle>
        <g filter="url(#ccpa_svg__e)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M82.995 2.18c2.524-6.222 7.477-10.02 9.639-11.14 2.054-.967 5.238-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.585 22.011-6.376 11.772-1.858 1.004-7.501 6.867s-5.782 6.643-12.763 14.655c-6.98 8.011-7.212 7.027-1.327-2.342s5.285-9.272 14.11-21.292S79.84 9.957 82.994 2.18Z"
          ></path>
        </g>
        <g filter="url(#ccpa_svg__f)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M89.557 16.617c2.524-6.221 7.478-10.02 9.64-11.14 2.054-.967 5.238-.116 1.537 11.02-4.626 13.918-7.208 10.24-13.584 22.012-6.377 11.771-1.859 1.003-7.502 6.867s-5.781 6.642-12.762 14.654-7.213 7.027-1.328-2.341 5.285-9.273 14.11-21.293 6.734-12.001 9.89-19.779Z"
          ></path>
        </g>
        <g filter="url(#ccpa_svg__g)">
          <path
            fill="#fff"
            fillOpacity="0.2"
            d="M43.331-16.238c.395-6.887 7.39-10.61 10.839-11.61 3.351-.836 10.28.603 11.189 13.044C66.494.746 58.666-3.9 54.749 8.906c-3.915 12.804-2.935.906-9.767 6.936-6.833 6.03-6.53 6.919-14.422 15.261-7.891 8.343-9.077 7.164-4.358-2.912s3.605-10.049 12.18-22.798c8.577-12.75 4.456-13.022 4.95-21.63Z"
          ></path>
        </g>
        <g filter="url(#ccpa_svg__h)">
          <path
            fill="#fff"
            fillOpacity="0.12"
            d="M-20.118 60.871c-1.172-7.402 10.652-9.536 16.71-9.678 5.927.012 19.052 3.49 24.146 17.308 6.367 17.272-9.292 10.05-12.958 22.936-3.667 12.887-5.142.18-16.033 4.876-10.89 4.695-10.089 5.747-22.287 12.672-12.199 6.926-14.702 5.314-8.808-4.376s3.854-9.967 16.096-21.51 4.598-12.975 3.134-22.228"
          ></path>
        </g>
        <g filter="url(#ccpa_svg__i)">
          <path
            fill="#fff"
            fillOpacity="0.16"
            d="M108.682 40.055c2.524-6.222 7.478-10.02 9.639-11.14 2.055-.967 5.239-.116 1.538 11.02-4.626 13.918-7.208 10.24-13.584 22.011-6.377 11.772-1.859 1.004-7.502 6.867s-5.781 6.643-12.762 14.655c-6.981 8.011-7.213 7.027-1.328-2.342s5.285-9.272 14.11-21.293 6.734-12 9.889-19.778"
          ></path>
        </g>
        <circle cx="48" cy="48" r="37" fill="#172C6E"></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          fill="url(#ccpa_svg__j)"
          fillOpacity="0.16"
        ></circle>
        <circle
          cx="48"
          cy="48"
          r="37"
          stroke="#282828"
          strokeWidth="2"
        ></circle>
        <path
          fill="#fff"
          d="M36.786 46.438h-2.488a2.4 2.4 0 0 0-.279-.858q-.21-.381-.54-.648a2.4 2.4 0 0 0-.761-.41 2.9 2.9 0 0 0-.926-.141q-.903 0-1.574.449-.67.443-1.04 1.295-.37.846-.37 2.057 0 1.244.37 2.09.375.847 1.046 1.28.67.43 1.55.431.495 0 .916-.13.426-.132.755-.381.33-.255.546-.62.222-.363.307-.83l2.488.012a4.64 4.64 0 0 1-1.511 2.87q-.643.58-1.534.92-.887.335-2.006.335-1.557 0-2.784-.704-1.221-.705-1.932-2.04-.704-1.335-.704-3.233 0-1.905.715-3.239.716-1.335 1.944-2.034 1.227-.705 2.761-.704 1.012 0 1.875.284.87.284 1.54.83.67.539 1.09 1.323.427.784.546 1.795Zm12.032 0h-2.49a2.4 2.4 0 0 0-.278-.858q-.21-.381-.54-.648a2.4 2.4 0 0 0-.76-.41 2.9 2.9 0 0 0-.927-.141q-.903 0-1.574.449-.67.443-1.04 1.295-.369.846-.369 2.057 0 1.244.37 2.09.375.847 1.045 1.28.67.43 1.551.431.495 0 .915-.13.426-.132.756-.381.33-.255.545-.62.222-.363.307-.83l2.489.012a4.64 4.64 0 0 1-1.511 2.87 4.8 4.8 0 0 1-1.535.92q-.886.335-2.006.335-1.557 0-2.784-.704-1.221-.705-1.932-2.04-.705-1.335-.704-3.233 0-1.905.716-3.239.716-1.335 1.943-2.034 1.227-.705 2.761-.704 1.012 0 1.875.284.87.284 1.54.83.67.539 1.091 1.323.426.784.546 1.795ZM50.582 54V42.364h4.59q1.325 0 2.256.505a3.42 3.42 0 0 1 1.42 1.392q.495.887.495 2.046t-.5 2.045a3.45 3.45 0 0 1-1.449 1.381q-.943.495-2.284.494h-2.926v-1.971h2.528q.711 0 1.17-.245a1.6 1.6 0 0 0 .694-.687 2.16 2.16 0 0 0 .233-1.017q0-.58-.233-1.012a1.56 1.56 0 0 0-.693-.676q-.466-.244-1.182-.244h-1.66V54zm11.021 0h-2.636l4.017-11.636h3.17L70.165 54H67.53l-2.915-8.977h-.09L61.602 54Zm-.165-4.574h6.227v1.92h-6.227z"
        ></path>
        <path
          fill="#F6AA23"
          d="m71.563 31.375-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.734c0 .254.292.423.5.254l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.65 1.042-1.397c.168-.212 0-.508-.25-.508h-1.71l-.96-1.438c-.167-.212-.5-.17-.584.084m-9.984-9.984-.542 1.65-1.67.508c-.25.084-.291.423-.083.55l1.377 1.015-.041 1.735c0 .254.291.423.5.254l1.419-1.016 1.626.593c.25.084.501-.127.418-.381l-.543-1.65 1.043-1.396c.168-.212 0-.508-.25-.508h-1.71l-.96-1.439c-.167-.211-.5-.169-.584.085M23.45 31.375l-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.734c0 .254.291.423.5.254l1.418-1.015 1.628.592c.25.085.5-.127.417-.38l-.542-1.65 1.043-1.397c.167-.212 0-.508-.25-.508h-1.711l-.96-1.438c-.167-.212-.5-.17-.584.084m9.988-9.984-.542 1.65-1.669.508c-.25.084-.292.423-.083.55l1.376 1.015-.041 1.735c0 .254.291.423.5.254l1.42-1.016 1.626.593c.25.084.5-.127.417-.381l-.542-1.65 1.043-1.396c.167-.212 0-.508-.25-.508h-1.711l-.96-1.439c-.167-.211-.5-.169-.584.085M47.81 16.85l-.543 1.651-1.669.508c-.25.084-.292.423-.084.55l1.378 1.015-.043 1.735c0 .254.293.423.501.254l1.419-1.016 1.627.593c.25.084.5-.127.417-.381l-.542-1.65 1.043-1.397c.166-.211 0-.507-.25-.507h-1.711l-.96-1.439c-.166-.211-.5-.169-.584.085Zm0 56.74-.543 1.65-1.669.507c-.25.085-.292.423-.084.55l1.378 1.016-.043 1.734c0 .254.293.423.501.254l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.651 1.043-1.396c.166-.212 0-.508-.25-.508h-1.711l-.96-1.438c-.166-.212-.5-.17-.584.084Zm13.769-4.54-.542 1.65-1.67.507c-.25.085-.291.423-.083.55l1.377 1.015-.041 1.735c0 .254.291.423.5.254l1.419-1.015 1.626.592c.25.085.501-.127.418-.38l-.543-1.651 1.043-1.396c.168-.212 0-.508-.25-.508h-1.71l-.96-1.439c-.167-.211-.5-.169-.584.085Zm-28.141 0-.542 1.65-1.669.507c-.25.085-.292.423-.083.55l1.376 1.015-.041 1.735c0 .254.291.423.5.254l1.42-1.015 1.626.592c.25.085.5-.127.417-.38l-.542-1.651 1.043-1.396c.167-.212 0-.508-.25-.508h-1.711l-.96-1.439c-.167-.211-.5-.169-.584.085Zm38.125-9.683-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.735c0 .253.292.423.5.253l1.419-1.015 1.627.592c.25.085.5-.127.417-.38l-.542-1.65 1.042-1.397c.168-.211 0-.508-.25-.508h-1.71l-.96-1.438c-.167-.212-.5-.17-.584.084m-48.113 0-.542 1.65-1.67.508c-.25.085-.291.423-.082.55l1.376 1.016-.041 1.735c0 .253.291.423.5.253l1.418-1.015 1.628.592c.25.085.5-.127.417-.38l-.542-1.65 1.043-1.397c.167-.211 0-.508-.25-.508h-1.711l-.96-1.438c-.167-.212-.5-.17-.584.084"
        ></path>
      </g>
      <path
        stroke="#fff"
        strokeOpacity="0.08"
        d="M48 .5C74.234.5 95.5 21.767 95.5 48c0 26.234-21.266 47.5-47.5 47.5C21.767 95.5.5 74.234.5 48 .5 21.767 21.767.5 48 .5Z"
      ></path>
    </g>
    <defs>
      <filter
        id="ccpa_svg__a"
        width="96"
        height="98"
        x="0"
        y="0"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="2"></feOffset>
        <feGaussianBlur stdDeviation="2"></feGaussianBlur>
        <feComposite
          in2="hardAlpha"
          k2="-1"
          k3="1"
          operator="arithmetic"
        ></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.16 0"></feColorMatrix>
        <feBlend in2="shape" result="effect1_innerShadow_250_8071"></feBlend>
      </filter>
      <filter
        id="ccpa_svg__e"
        width="59.057"
        height="78.256"
        x="45.817"
        y="-18.257"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8071"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="ccpa_svg__f"
        width="59.057"
        height="78.256"
        x="52.38"
        y="-3.819"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8071"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="ccpa_svg__g"
        width="60.047"
        height="82.682"
        x="14.423"
        y="-37.042"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8071"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <filter
        id="ccpa_svg__h"
        width="109.64"
        height="107.036"
        x="-64.897"
        y="28.693"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8071"
          stdDeviation="11.25"
        ></feGaussianBlur>
      </filter>
      <filter
        id="ccpa_svg__i"
        width="59.057"
        height="78.256"
        x="71.505"
        y="19.618"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        ></feBlend>
        <feGaussianBlur
          result="effect1_foregroundBlur_250_8071"
          stdDeviation="4.5"
        ></feGaussianBlur>
      </filter>
      <linearGradient
        id="ccpa_svg__c"
        x1="48"
        x2="48"
        y1="0"
        y2="96"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.2"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.02"></stop>
      </linearGradient>
      <linearGradient
        id="ccpa_svg__d"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0.2"></stop>
      </linearGradient>
      <linearGradient
        id="ccpa_svg__j"
        x1="48"
        x2="48"
        y1="12"
        y2="84"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="ccpa_svg__b">
        <path
          fill="#fff"
          d="M0 48C0 21.49 21.49 0 48 0s48 21.49 48 48-21.49 48-48 48S0 74.51 0 48"
        ></path>
      </clipPath>
    </defs>
  </svg>
);
